<template>
    <footer class="site-footer center-content-mobile" :class="topOuterDivider && 'has-top-divider'">
        <div class="container">
            <div class="site-footer-inner" :class="topDivider && 'has-top-divider'">
                <div class="footer-top space-between text-xxs">
                    <c-logo />
                </div>
                <div class="footer-bottom space-between text-xxs invert-order-desktop">
                    <c-footer-nav />
                    <div class="footer-copyright">&copy; Line-1 Logistics Pty Ltd &middot; Licensed Customs Broker &middot; Perth, Western Australia
                 <br/>台州一号线企业管理有限公司 <a href="https://beian.miit.gov.cn" ><span
                id='sp_beian'>浙ICP备19014329号-3</span></a>
                 <br/>Powered By Line1.tech</div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import CLogo from '@/components/layout/partials/Logo.vue'
import CFooterNav from '@/components/layout/partials/FooterNav.vue'

export default {
  name: 'CFooter',
  components: {
    CLogo,
    CFooterNav
  },
  props: {
    topOuterDivider: {
      type: Boolean,
      default: false
    },      
    topDivider: {
      type: Boolean,
      default: false
    }
  }
}
</script>